import axios from "axios";
import { getToken } from "../Utlis/UpdateUsersState";

const getAllApiKeys = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}api-keys/`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const createApiKey = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}api-keys/`,
      data,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const deleteApiKey = async (key_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}api-keys/?key_id=${key_id}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const renewApiKey = async (key_id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}api-keys/renew/?key_id=${key_id}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

const getStatsAPI = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}api-keys/stats/`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

export { getAllApiKeys, createApiKey, deleteApiKey, renewApiKey, getStatsAPI };
